import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Fängt Render-Fehler ab, damit die ganze App nicht weiß bleibt.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('UI-Fehler:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            p: 3,
            textAlign: 'center',
            bgcolor: 'var(--bg-secondary, #f8f9fa)',
            color: 'var(--text-primary, #1a1a1a)',
          }}
        >
          <Typography variant="h5" component="h1" sx={{ fontWeight: 700 }}>
            Etwas ist schiefgelaufen
          </Typography>
          <Typography variant="body1" sx={{ maxWidth: 420, opacity: 0.8, fontWeight: 400 }}>
            Die Seite konnte nicht geladen werden. Das System läuft weiter — bitte neu laden
            oder zum Dashboard zurückkehren.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button variant="contained" onClick={this.handleReload}>
              Neu laden
            </Button>
            <Button variant="outlined" onClick={this.handleHome}>
              Zum Dashboard
            </Button>
          </Box>
        </Box>
      );
    }
    return this.props.children;
  }
}
